import React, { useState, useEffect } from 'react'
import { getBaseMap } from '../../components/different-maps';
import Navigation from '../../components/navigation';
import { useSearchParams } from 'react-router-dom';
import Spinner from 'react-bootstrap/Spinner';

import LoginForm from '../../components/LoginForm';
import { useNavigate } from 'react-router-dom';

import GeneralApi from "../../services/openapi/api/GeneralApi.js"

import "./styles.css"

function Map() {
  const [searchParams] = useSearchParams();
  const [loginForm, setLoginForm] = useState(false);
  const [user, setUser] = useState(false);
  const navigate = useNavigate();

  const generalApi = new GeneralApi();

  useEffect(() => {

    getBaseMap(searchParams.get("x") ? searchParams.get("x") : undefined, searchParams.get("y") ? searchParams.get("y") : undefined, searchParams.get("defaultLayers") ? searchParams.get("defaultLayers") : undefined, searchParams.get("scale") ? searchParams.get("scale") : undefined)

    generalApi.userinfo().then((response) => {
      setUser(response)
    });

  }, [])

  return (
    <div className="Map">
      <Navigation
        showLoginForm={() => { setLoginForm(!loginForm); }}
        user={user}
      />
      {loginForm &&
        <LoginForm
          afterLogin={() => {
            generalApi.userinfo().then((response) => {
              setUser(response)
              navigate('/lk/MyDatasets')
            });
            setLoginForm(false);
          }}
        />
      }
      <div id="mapContainer" className='map-base' />
      <div className="spinner-container">
        <Spinner animation="border" variant="info" />
      </div>
    </div>
  );
}

export default Map;